var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('TabView',{on:{"tab-change":_vm.handleTabChange}},[_c('TabPanel',{attrs:{"header":"สรุปจำนวนอาคาร/สิ่งปลูกสร้าง"}},[_c('report-building-amount')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }